import i18n from 'i18n'

interface FormatDecimalsOptions {
  decimals?: number
  currency?: string
}

export const formatDecimals = (value?: number | string | null, options: FormatDecimalsOptions = { decimals: 2 }): string => {
  const number = typeof value === 'string' ? parseFloat(value) : value
  if (number === null || number === undefined || isNaN(number)) {
    return '—'
  }
  if (options.currency) {
    return new Intl.NumberFormat(i18n.language, {
      style: 'currency',
      maximumFractionDigits: options.decimals,
      currency: options.currency,
      currencyDisplay: 'code',
    }).format(number)
  }
  return new Intl.NumberFormat(i18n.language, {
    maximumFractionDigits: options.decimals,
  }).format(number)
}

export const formatBytes = (bytes: number): string => {
  const units = [
    'byte',
    'kilobyte',
    'megabyte',
    'gigabyte',
  ]
  const k = 1024
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), 3)
  const value = bytes / Math.pow(k, i)

  return new Intl.NumberFormat(i18n.language, {
    style: 'unit',
    unit: units[i],
    unitDisplay: 'short',
    // NOTE: use decimals only for MB and up
    maximumFractionDigits: i >= 2 ? 2 : 0,
  }).format(value)
}
